// extracted by mini-css-extract-plugin
export default {"container":"Fy3YwA","wrapper":"NGDMeV","logo":"RmhCbh","message":"f2tAgg","contact":"xFtcy4","mobile":"F4Sb1e"};